import React, { useMemo } from "react";
import * as Scrivito from "scrivito";
import { priceToString } from "utils/priceToString";
import { useTranslate } from "hooks";
import { EllipsisWithTooltip } from "components/EllipsisWithTooltipText";
import { tableColumnsWidths } from "variables";
import type { ProductListTableProduct } from "interfaces/product/product.types";

type ProductListTableRowProps = {
  product: ProductListTableProduct;
  fetchingPrices: boolean;
};

export const ProductListTableRow = Scrivito.connect(
  ({ product, fetchingPrices }: ProductListTableRowProps) => {
    const {
      title,
      presentation,
      quantity,
      unitPrice,
      totalPrice = null,
      fullPriceGroup = null,
    } = product;
    const translate = useTranslate();

    const { unitPriceString, totalPriceString } = useMemo(
      () => ({
        unitPriceString: unitPrice
          ? priceToString({
              price: unitPrice,
              noPriceText: translate("NO_PRICE") as string,
            })
          : null,
        totalPriceString: totalPrice
          ? priceToString({
              price: totalPrice,
              noPriceText: translate("NO_PRICE") as string,
            })
          : null,
      }),
      [unitPrice, translate, totalPrice],
    );

    return (
      <>
        <td style={{ width: tableColumnsWidths.nameWidth }}>
          <div className="text-gray-700 fw-bold text-truncate mw-100">
            <EllipsisWithTooltip text={title} />
          </div>
        </td>
        <td
          className="text-break text-nowrap overflow-hidden text-truncate"
          style={{ width: tableColumnsWidths.orderCodeWidth }}
        >
          <EllipsisWithTooltip text={presentation} />
        </td>
        <td
          style={{
            width: tableColumnsWidths.quantityWidth,
          }}
        >
          {quantity}
        </td>

        {fetchingPrices ? (
          <>
            <td
              style={{
                width: tableColumnsWidths.unitPriceWidth,
              }}
            >
              <div className="shortloadingLine col-8 rounded"></div>
            </td>
            <td
              style={{
                width: tableColumnsWidths.totalPriceWidth,
              }}
            >
              <div className="shortloadingLine col-8 rounded"></div>
            </td>
            <td
              style={{
                width: tableColumnsWidths.priceGroupWidth,
              }}
            >
              <div className="shortloadingLine col-8 rounded"></div>
            </td>
          </>
        ) : (
          <>
            <td
              style={{
                width: tableColumnsWidths.unitPriceWidth,
              }}
            >
              {unitPriceString}
            </td>
            <td
              className="text-break"
              style={{
                width: tableColumnsWidths.totalPriceWidth,
              }}
            >
              {totalPriceString}
            </td>
            <td
              className="text-break text-wrap overflow-hidden text-truncate"
              style={{
                width: tableColumnsWidths.priceGroupWidth,
              }}
            >
              {fullPriceGroup}
            </td>
          </>
        )}
      </>
    );
  },
);
